import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-public-layout',
  imports: [RouterOutlet,RouterModule,CommonModule],
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss',
})
export class PublicLayoutComponent {
currentRoute: string = '';
  user$: Observable<User | null>;
  showNavbar: boolean = true;
  constructor(private router: Router, public auth: AuthService){
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
    this.currentRoute = event.urlAfterRedirects;
    this.user$ = this.auth.user$;
  });
   this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: any) => {
      this.showNavbar = !event.url.includes('print-application');
    });
}
  title = 'rental-portal';
   // Navigate to Apply page
   goToApply() {
    this.router.navigate(['/apply']);
  }

  // Navigate to Pay Rent page
  goToPay() {
    this.router.navigate(['/pay']);
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }
  goToDashboard() {
    this.router.navigate(['/tenant']);
  }
  async logout() {
    await this.auth.logout();
    this.router.navigateByUrl('/login');
  }
}
